import AddPillButtonWithRef from './AddPillButton';

export default AddPillButtonWithRef;
